<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="tabsAccessControl"
    :selectedIndex="
      getHeaderFormData.selectedIndex != undefined
        ? getHeaderFormData.selectedIndex
        : undefined
    "
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="screenJson.title"
        :createModeIsEditMode="getHeaderFormData.title.createModeIsEditMode"
        :baseView="baseView"
        :primaryLabel="headerTitlePrimary"
        :secondaryLabel="headerTitleSecondary"
        v-if="headerTitlePrimary"
      />
    </template>

    <div class="css-v2 transaction-screen">
      <gc-header-form-split
        :headerOptions="getHeaderFormData"
        :data="transactionData"
        :saveTransaction="saveTransaction"
        v-if="
          getHeaderFormData.headerFormSplitView &&
          dataLoaded &&
          getHeaderFormData.headerFormVisible != false &&
          !refreshHeaderForm
        "
        v-show="!gridExpand"
        :backButtonRoute="backButtonRoute"
        ref="gc-header-form-component"
        :getHeaderToolbar="getHeaderToolbar"
        :setLoading="showLoading"
        :formContentReady="
          getHeaderFormData.formContentReady
            ? getHeaderFormData.formContentReady
            : undefined
        "
      ></gc-header-form-split>
      <gc-header-form
        :headerOptions="getHeaderFormData"
        :data="transactionData"
        :saveTransaction="saveTransaction"
        v-if="
          !getHeaderFormData.headerFormSplitView &&
          dataLoaded &&
          getHeaderFormData.headerFormVisible != false &&
          !refreshHeaderForm
        "
        v-show="!gridExpand"
        :backButtonRoute="backButtonRoute"
        ref="gc-header-form-component"
        :getHeaderToolbar="getHeaderToolbar"
        :setLoading="showLoading"
        :formContentReady="
          getHeaderFormData.formContentReady
            ? getHeaderFormData.formContentReady
            : undefined
        "
      ></gc-header-form>

      <!-- <gc-header-form :header-options="getHeaderFormData"></gc-header-form> -->
      <div class="data-grid-details">
        <GcDataGrid
          :grouping="true"
          :export="true"
          :summary="true"
          :dataSourceConfig="
            screenJson.gridData
              ? screenJson.gridData.gridOptions.dataSource
              : undefined
          "
          :columns="getColumns"
          :valueChangeListners="getListners"
          :childGridColumns="getChildGridColumns"
          :gridToolbar="
            screenJson.gridData ? screenJson.gridData.toolbar : undefined
          "
          :padColumn="true"
          :id="'transaction-grid'"
          v-if="dataLoaded && screenJson.gridData && !refreshDataGrid"
          ref="transactionGrid"
          :isLocalDataSource="localDataGrid"
          :isEditableGrid="true"
          :showFooter="footerEnabled"
          :gridOptions="
            screenJson.gridData ? screenJson.gridData.gridOptions : undefined
          "
          :dataModel="transactionData"
          :saveCallBack="saveTransaction"
          :elementAttrClass="'transaction-template'"
          :dxScrolling="dxScrolling"
          :heightPadding="showFooter && footerEnabled ? 5 + batchPadding : 20 + batchPadding"
          :paging="paging"
        />
      </div>
      <GcFooter v-if="showFooter && footerEnabled && !refreshDataGrid">
        <template #leftContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerLeftItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>

            <label
              v-if="item.fieldType == 'custome-string'"
              class="gc-footer-value"
              >{{ item.value }}</label
            >
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 6"
              v-else
            />
          </div>
        </template>
        <template #rightContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerRightItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 6"
            />
          </div>
        </template>
      </GcFooter>
    </div>
    <gc-popup
      :popup-visible="commentsPopupVisible"
      :popup-title="commentPopUpConfig ? commentPopUpConfig.title : 'Comments'"
      :back-button-function="popUpBackButtonClick"
      :popupHeight="'auto'"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'top',
          }"
          :formItems="commentPopUpItems"
          :formHeight="'auto'"
          :isNormal="true"
          :data-model="transactionData"
          :formMode="baseView.mode"
          :validationGroup="'gc-transaction-comments-form-data'"
          :formTitle="'comments'"
          v-if="commentPopUpItems"
          :valueChangeCallBack="commentCalueChangeCallBack"
          :checkValid="isValid"
          :fromFrom="'gc-transaction-template-comments'"
        ></gc-form>
      </div>
    </gc-popup>

    <gc-popup
      :popup-visible="gcPopupVisible"
      :popup-title="gcPopupConfig.title"
      :back-button-function="popUpBackButtonClick"
      :popupHeight="'auto'"
      v-if="gcPopupConfig && gcPopupVisible"
      :saveValidation="gcPopUpSaveOption"
      :saveButtonConfig="gcPopupConfig.save"
      :backButtonConfig="gcPopupConfig.back"
      :data-model="
        gcPopupConfig.dataModel ? gcPopupConfig.dataModel : transactionData
      "
      :popupWidth="
        gcPopupConfig.popupWidth ? gcPopupConfig.popupWidth : undefined
      "
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="gcPopupConfig.formOptions"
          :formItems="gcPopupConfig.items"
          :formHeight="gcPopupConfig.height ? gcPopupConfig.height : 'auto'"
          :isNormal="true"
          :data-model="
            gcPopupConfig.dataModel ? gcPopupConfig.dataModel : transactionData
          "
          :formMode="baseView.mode"
          :validationGroup="'gcPopupConfig-gc-popup-form-data'"
          :formTitle="'gc-popup'"
          v-if="gcPopupConfig.items"
          :valueChangeCallBack="gcPopupConfigValueChangeCallBack"
          :checkValid="gcPopupIsValid"
        ></gc-form>
      </div>
    </gc-popup>

    <gc-item-price-update
      v-if="itemPriceUpdate && itemPriceUpdate.visible"
      :setVisible="itemPriceUpdate.visible"
      :callBack="itemPriceUpdate.popUpCallBack"
      :itemPriceUpdateData="itemPriceUpdate.itemPriceUpdateData"
      :branchCode="itemPriceUpdate.model.BranchCode"
      :baseView="baseView"
      :setLoading="showLoading"
    ></gc-item-price-update>

    <GcPopUpEditProductItem
      v-if="editProductItem && editProductItem.visible"
      :setVisible="editProductItem.visible"
      :callBack="editProductItem.popUpCallBack"
      :editProductItemData="editProductItem.editProductItemData"
      :formContentReady="editProductItem.formContentReady"
      :baseView="baseView"
      :setLoading="showLoading"
    ></GcPopUpEditProductItem>

    <GcPopUpAddSalesOrderItem
      v-if="addSalesOrderItem && addSalesOrderItem.visible"
      :setVisible="addSalesOrderItem.visible"
      :callBack="addSalesOrderItem.popUpCallBack"
      :addSalesOrderItemData="addSalesOrderItem.addSalesOrderItemData"
      :formContentReady="addSalesOrderItem.formContentReady"
      :baseView="baseView"
      :setLoading="showLoading"
    ></GcPopUpAddSalesOrderItem>

    <GcPopUpAlmondcoDespatchData
      v-if="almondcoDespatchData"
      :setVisible="almondcoDespatchData.visible"
      :almondcoDespatchData="almondcoDespatchData"
      :setLoading="showLoading"
      :showValidationSummary="showValidationSummary"
    />
    <GcSundryTransactionPopup
      v-if="gcSundryTransactionPopupConfig.gcPopupVisible"
      :visible="gcSundryTransactionPopupConfig.gcPopupVisible"
      :gcSundryTransactionPopupConfig="gcSundryTransactionPopupConfig"
      :setLoading="showLoading"
      :showValidationSummary="showValidationSummary"
    />
    <GcPopupGeneralDataGrid
      :gcPopupDataGridVisible="gcPopupDataGridVisible"
      :gcPopupDataGridConfig="gcPopupDataGridConfig"
      :popUpBackButtonClick="popUpBackButtonClick"
      v-if="gcPopupDataGridVisible"
    />

    <GcPopupBankFee
      v-if="gcPopupBankFeeConfig.visible"
      :visible="gcPopupBankFeeConfig.visible"
      :callback="gcPopupBankFeeConfig.callback"
      :bankFeeSettings="gcPopupBankFeeConfig.bankFeeSettings"
      :setLoading="showLoading"
    />

    <GcPopupBankTransfer
      v-if="gcPopupBankTransferConfig.visible"
      :visible="gcPopupBankTransferConfig.visible"
      :callback="gcPopupBankTransferConfig.callback"
      :showValidationSummary="showValidationSummary"
      :setLoading="showLoading"
    />

    <GcPopupLinkAnItem
      v-if="linkAnItem && linkAnItem.visible"
      :setVisible="linkAnItem.visible"
      :callBack="linkAnItem.popUpCallBack"
      :linkAnItemData="linkAnItem.linkAnItemData"
      :formContentReady="linkAnItem.formContentReady"
      :baseView="baseView"
      :setLoading="showLoading"
    ></GcPopupLinkAnItem>

    <GcPopUpSearchForItem
      v-if="searchForItem && searchForItem.visible"
      :setVisible="searchForItem.visible"
      :callBack="searchForItem.popUpCallBack"
      :baseView="baseView"
      :setLoading="showLoading"
      :productListQuery="
        searchForItem.productListQuery
          ? searchForItem.productListQuery
          : undefined
      "
      :productListColumns="
        searchForItem.columns ? searchForItem.columns : undefined
      "
      :productListItems="
        searchForItem.productListItems
          ? searchForItem.productListItems
          : undefined
      "
      :title="'Search Product'"
    />
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import { TransactionService } from "../_services/api/templates/transactions.services";
import { mapGetters } from "vuex";
import FormMixin from "@/_mixins/form.mixin";
// eslint-disable-next-line no-unused-vars
import { getFactorByCode } from "../_store/helpers";
import { getDefaultCustomerSettings, getGlobalField } from "../_store/helpers";
import { tabAccessControl } from "../_helpers/access-control";
import { SalesOrderTypeService } from "../_services/api/sales/sales-order-type.service";
// import SalesFormulas from "@/_helpers/formulas/sales-formulas.js";

// const { calculateDiscLineTotal, calculateTaxLineTotal } = SalesFormulas;

import gcHeaderFormSplit from "../components/gc-header-form-split.vue";

export default {
  props: {
    dxScrolling: {
      type: String,
      default: "virtual",
    },
    paging: {
      type: Boolean,
      default: true,
    },
    itemPriceUpdate: {
      type: Object,
      default: () => {},
    },
    editProductItem: {
      type: Object,
      default: () => {},
    },
    linkAnItem: {
      type: Object,
      default: () => {},
    },
    addSalesOrderItem: {
      type: Object,
      default: () => {},
    },
    screenJson: {
      type: Object,
      default: () => {},
    },
    headerScreenJson: {
      type: Object,
      default: () => {},
    },
    itemCount: {
      type: Number,
      default: () => 0,
    },
    saveModel: {
      type: Object,
      default: () => {},
    },
    setLoading: {
      type: Boolean,
      default: false,
    },
    localDataGrid: {
      type: Boolean,
      default: true,
    },
    backButtonRoute: {
      type: String,
      default: undefined,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    backRouteAppend: {
      type: String,
      default: undefined,
    },
    isLoaded: {
      type: Boolean,
      default: true,
    },
    validationSummary: {
      type: Array,
      default: () => [],
    },
    serverError: {
      type: Object,
      default: () => {},
    },
    getHeaderToolbar: {
      type: Object,
      default: () => {},
    },
    gcPopupConfig: {
      type: Object,
      default: () => {},
    },
    gcSundryTransactionPopupConfig: {
      type: Object,
      default: () => {
        return {
          gcPopupVisible: false,
        };
      },
    },
    warningSummary: {
      type: Array,
      default: () => [],
    },
    refreshColumns: {
      type: Number,
      default: () => 0,
    },
    almondcoDespatchData: {
      type: Object,
      default: () => {},
    },

    gcPopupDataGridConfig: {
      type: Object,
      default: () => {},
    },
    refreshDataGridProp: {
      type: Boolean,
      default: false,
    },
    refreshHeaderFormProp: {
      type: Boolean,
      default: false,
    },
    searchForItem: {
      type: Object,
      default: () => {},
    },
    gcPopupBankFeeConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    gcPopupBankTransferConfig: {
      type: Object,
      default: () => {
        return {
          visible: false,
        };
      },
    },
    batchPadding: {
      type: Number,
      default: 0,
    },
  },
  mixins: [RouteMixin, FormMixin],
  components: {
    gcHeaderFormSplit,
  },

  data() {
    return {
      // backButtonRoute: `/invoiced-order`,
      transactionData: undefined,
      headerTitlePrimary: undefined,
      headerTitleSecondary: undefined,
      dataLoaded: false,
      columns: undefined,
      footerItems: [],
      showFooter: false,
      // commnts popup
      isValid: false,
      gcPopupVisible: false,
      footerEnabled: true,
      childGridColumns: undefined,
      refreshDataGrid: false,
      gcPopupDataGridVisible: false,
      gcPopupIsValid: false,

      refreshHeaderForm: false,
    };
  },
  beforeMount() {
    this.$store.dispatch("dataContext/setDataViewType", undefined);
  },
  beforeDestroy() {
    this.$store.dispatch("ui/setGridExpand", false);
    // this.$store.dispatch("dataContext/setDataViewType", undefined);
    // this.$store.dispatch("dataContext/setReviewDataSource", []);
  },
  computed: {
    ...mapGetters({ displayServerErrorPopUp: "ui/getServerError" }),
    getChildGridColumns() {
      if (this.childGridColumns) {
        return this.childGridColumns;
      } else return this.screenJson.gridData.childColumns;
    },
    tabsAccessControl() {
      if (this.getHeaderFormData.tabs)
        return tabAccessControl(this.getHeaderFormData.tabs);
      else return [];
    },
    commentsPopupVisible: {
      get() {
        return this.transactionCommentPopUp;
      },
      set() {
        return false;
      },
    },
    ...mapGetters({ commentPopUpItems: "ui/getCommentPopUpItems" }),
    ...mapGetters({ transactionCommentPopUp: "ui/getTransactionCommentPopUp" }),
    commentPopUpConfig() {
      return {
        title: this.getHeaderToolbar
          ? this.getHeaderToolbar.headerToolbar.commentsTitle
          : this.getHeaderFormData.headerToolbar.commentsTitle,
      };
    },
    getHeaderToolbarData() {
      if (this.getHeaderToolbar) return this.getHeaderToolbar;
      else return this.getHeaderFormData;
    },
    getHeaderFormData() {
      if (this.headerScreenJson) return this.headerScreenJson.headerData;
      else return this.screenJson.headerData;
    },
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({ getDataContext: ["dataContext/getDataContext"] }),
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),

    getColumns() {
      return this.columns;
    },
    getListners() {
      return this.screenJson.gridData
        ? this.screenJson.gridData.valueChangedEventListners
        : undefined;
    },
    footerLeftItems() {
      var leftItems = this.footerItems.filter(
        (x) =>
          x.location == "left" &&
          (x.hasOwnProperty("visible") ? x.visible : true)
      );

      return leftItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };
          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;
          if (c.fieldType != undefined) globalField.fieldType = c.fieldType;
          if (c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${
                getDefaultCustomerSettings().CustomerCurrency
                  ? getDefaultCustomerSettings().CustomerCurrency
                  : ""
              })`
            );
          }
          // if(c.length != undefined) globalField.length = c.length;
          // if (globalField.type === "Decimal") {
          //   globalField.label = globalField.label.replace(
          //     "(Customer Currency)",
          //     `(${getDefaultCustomerSettings().CustomerCurrency})`
          //   );
          // }
          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    footerRightItems() {
      // return this.footerItems.filter((x) => x.location == "right");
      var rightItems = this.footerItems.filter(
        (x) =>
          x.location == "right" &&
          (x.hasOwnProperty("visible") ? x.visible : true)
      );

      return rightItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };

          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;

          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${
                getDefaultCustomerSettings().CustomerCurrency
                  ? getDefaultCustomerSettings().CustomerCurrency
                  : ""
              })`
            );
          }

          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    dataChangedIndex() {
      return this.$store.state.dataContext.dataChangedIndex;
    },
  },

  async created() {
    this.showLoading(this.setLoading);
    if (!this.screenJson.footerData) this.footerEnabled = false;
    if (
      (this.getHeaderToolbarData.headerToolbar.pdf == true &&
        this.getHeaderToolbarData.headerToolbar.screenName) ||
      (this.screenJson.gridData &&
        this.screenJson.gridData.toolbar.pdf == true &&
        this.screenJson.gridData.toolbar.screenName)
    )
      this.$store.dispatch("reportPdfPreview/setReportPreviewScreens");
    this.$store.dispatch("ui/setCommentPopUpItems", []);
    if (this.isLoaded) this.getTransactions();
  },
  methods: {
    gcPopUpSaveOption() {
      this.gcPopupIsValid = true;
    },
    gcPopupConfigValueChangeCallBack(isValid, brokenRules) {
      this.gcPopupIsValid = false;
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.gcPopupConfig.save.clickCallback(
          this.gcPopupConfig.dataModel
            ? this.gcPopupConfig.dataModel
            : this.transactionData
        );
      }
    },
    showValidationSummary(val) {
      if (val.length > 0) {
        this.displayValidationSummary(val);
      }
    },
    commentCalueChangeCallBack(isValid, brokenRules) {
      this.isValid = false;
      if (!isValid) this.saveTransaction(isValid, brokenRules);
      else this.isValid = true;
    },
    popUpBackButtonClick() {
      this.commentsPopupVisible = false;
      this.gcPopupVisible = false;
      this.gcPopupDataGridVisible = false;

      if (this.gcPopupConfig) this.gcPopupConfig.callBack();
      if (this.gcPopupDataGridConfig) this.gcPopupDataGridConfig.callBack();

      this.$store.dispatch("ui/setTransactionCommentPopUp", false);
    },
    getTransactionData() {
      return this.transactionData;
    },
    updateValue(dataField, items) {
      let result = 0;
      if (items.length > 0)
        items.forEach((x) => {
          if (x.CheckInclude || this.baseView.mode == "review")
            result += parseFloat(x[dataField]).roundNumber(4);
          else if (x.CheckInclude == undefined)
            result += parseFloat(x[dataField]).roundNumber(4);
        });

      return result;
    },
    setFooterItems() {
      if (!this.footerEnabled) return;
      this.showFooter = false;
      let gridItems = this.getDataContext("gcDataGrid");

      if (!gridItems || gridItems.length == 0) {
        setTimeout(() => {
          this.$store.dispatch("ui/checkGridNoData", true);
        }, 1000);
        // return;
      }

      this.screenJson.footerData.footerItems
        .filter((x) => (x.hasOwnProperty("visible") ? x.visible : true))
        .forEach((x) => {
          x.value = this.updateValue(x.dataField, gridItems);
          if (x.customCalc)
            x.value = x.customCalc(this.transactionData, gridItems);
        });

      this.footerItems = this.screenJson.footerData.footerItems;

      this.showFooter = true;
    },

    backButtonFunction() {
      this.$router
        .push({
          path: this.backRouteAppend
            ? this.backButtonRoute + this.transactionData[this.backRouteAppend]
            : this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
          this.$store.dispatch("dataContext/setReviewDataSource", []);
        });
    },
    async getTransactions() {
      this.showLoading(false);
      if (!this.screenJson.endpoint.primary) {
        if (this.dataModel) this.transactionData = this.dataModel;

        if (this.transactionData && this.transactionData.CustomerCode) {
          if (
            this.transactionData.Customer &&
            this.transactionData.Customer.CurrencyCode
          ) {
            this.$store.dispatch(
              "defaultCustomerSettings/setCustomerCurrencyCode",
              this.transactionData.Customer.CurrencyCode
            );
          } else {
            if (this.transactionData && this.transactionData.CurrencyCode)
              this.$store.dispatch(
                "defaultCustomerSettings/setCustomerCurrencyCode",
                this.transactionData.CurrencyCode
              );
            else
              this.$store.dispatch(
                "defaultCustomerSettings/setCustomerById",
                this.transactionData.CustomerCode
              );
          }
        }
        // this.$store.dispatch(
        //   "ui/setCommentPopUpItems",
        //   this.getHeaderToolbarData.headerToolbar.commentItems
        // );

        if (
          this.getHeaderToolbarData.headerToolbar.notes ||
          this.getHeaderToolbarData.headerToolbar.commentsAsForm
        ) {
          await this.setOrderComments();
        } else if (this.getHeaderToolbarData.headerToolbar.commentItems) {
          if (
            this.getHeaderToolbarData.headerToolbar.commentItems[0].items
              .length > 0
          ) {
            this.$store.dispatch(
              "ui/setCommentPopUpItems",
              this.getHeaderToolbarData.headerToolbar.commentItems
            );
          }
        }

        this.setHeaderTitle(this.getHeaderFormData.title);
        this.setColumnsData();
      } else {
        var filter = undefined;

        var postProcess = this.screenJson.endpoint.postProcess;
        if (this.screenJson.endpoint.filter) {
          filter = this.screenJson.endpoint.filter;
        } else {
          if (this.screenJson.endpoint.CodeBy == "text")
            filter = `Code eq '${this.baseView.id}'`;
          else filter = `Code eq ${this.baseView.id}`;
        }

        if (this.screenJson.endpoint.expand)
          filter = filter + `&$expand=${this.screenJson.endpoint.expand}`;

        if (this.screenJson.endpoint.select)
          filter = filter + `&$select=${this.screenJson.endpoint.select}`;

        this.showLoading(true);
        await TransactionService.getByCode(
          this.screenJson.endpoint.primary,
          filter
        )
          .then(async (res) => {
            if (res) {
              this.transactionData = res.data.value[0];

              if (postProcess)
                await this.screenJson.endpoint.postProcess(
                  this.transactionData
                );

              this.setHeaderTitle(this.getHeaderFormData.title);

              if (this.transactionData.CustomerCode)
                if (
                  this.getHeaderToolbarData.headerToolbar.notes ||
                  this.getHeaderToolbarData.headerToolbar.commentsAsForm
                ) {
                  // this.$store.dispatch(
                  //   "defaultCustomerSettings/setCustomerById",
                  //   this.transactionData.CustomerCode
                  // );
                  if (
                    this.transactionData.Customer &&
                    this.transactionData.Customer.CurrencyCode
                  ) {
                    this.$store.dispatch(
                      "defaultCustomerSettings/setCustomerCurrencyCode",
                      this.transactionData.Customer.CurrencyCode
                    );
                  } else {
                    this.$store.dispatch(
                      "defaultCustomerSettings/setCustomerById",
                      this.transactionData.CustomerCode
                    );
                  }

                  // var head = this.getHeaderToolbarData.headerToolbar;
                  await this.setOrderComments();
                }
              this.showLoading(false);
              this.setColumnsData();
            }
          })
          .catch((err) => {
            this.showLoading(false);
            this.setHeaderTitle(this.getHeaderFormData.title);
            this.$logger.debug("getTransactions err ", err);

            this.displayServerError(err, "Record Not Found");
          });
      }
    },

    async setOrderComments() {
      if (this.getHeaderToolbarData.headerToolbar.orderComments) {
        await SalesOrderTypeService.getByCode(
          this.transactionData[
            this.getHeaderToolbarData.headerToolbar.orderComments.dataField
          ]
        )
          .then((soType) => {
            var commentConfig = soType.data.value[0];

            if (commentConfig)
              this.getHeaderToolbarData.headerToolbar.orderComments.toMatch.forEach(
                (element, i) => {
                  var item = {
                    dataField: element,
                    label: {
                      text: commentConfig["CommentLabel" + (i + 1)],
                    },
                    cssClass: "gc-header-comment-item-container",
                    editorType: "dxTextArea",
                    editorOptions: {
                      maxLength: 100,
                      autoResizeEnabled: true,
                    },
                    visible: commentConfig["CommentLabel" + (i + 1)] != "",
                    validationRules:
                      commentConfig["CommentRequired" + (i + 1)] == "Y"
                        ? [
                            {
                              type: "required",
                              message: `${
                                commentConfig["CommentLabel" + (i + 1)]
                              } is required`,
                              validationMessageMode: "always",
                            },
                          ]
                        : [],
                  };

                  this.getHeaderToolbarData.headerToolbar.commentItems[0].items.push(
                    item
                  );
                  if (
                    this.baseView.mode == "create" &&
                    !this.getHeaderToolbarData.headerToolbar.orderComments
                      .keepComments
                  ) {
                    this.transactionData[element] = "";
                  }
                }
              );
            this.showLoading(false);
          })
          .catch((err) => {
            this.showLoading(false);
            this.$logger.debug("getSoType err ", err);
          });
      }
      this.showLoading(false);
      this.$store.dispatch(
        "ui/setCommentPopUpItems",
        this.getHeaderToolbarData.headerToolbar.commentItems
      );
    },

    setHeaderTitle(title) {
      var primaryText = title.primary;
      if (primaryText) {
        if (primaryText.customFunction) {
          this.headerTitlePrimary = primaryText.customFunction(
            this.transactionData
          );
        } else {
          if (primaryText.primary.text) {
            this.headerTitlePrimary = primaryText.primary.text;
            if (primaryText.primary.dataField)
              this.headerTitlePrimary =
                primaryText.primary.text +
                this.transactionData[primaryText.primary.dataField];
          } else {
            if (primaryText.primary.dataField)
              this.headerTitlePrimary =
                this.transactionData[primaryText.primary.dataField];
          }

          if (primaryText.secondary)
            if (primaryText.secondary.text) {
              this.headerTitlePrimary =
                this.headerTitlePrimary + primaryText.secondary.text;
              if (primaryText.secondary.dataField)
                this.headerTitlePrimary =
                  this.headerTitlePrimary +
                  this.transactionData[primaryText.secondary.dataField];
            } else {
              if (primaryText.secondary.dataField)
                this.headerTitlePrimary =
                  this.headerTitlePrimary +
                  this.transactionData[primaryText.secondary.dataField];
            }
        }
      }

      if (title.secondary.text) {
        this.headerTitleSecondary = title.secondary.text;
        if (title.secondary.dataField)
          this.headerTitleSecondary =
            this.headerTitleSecondary +
            this.transactionData[title.secondary.dataField];
      } else {
        if (title.secondary.dataField)
          this.headerTitleSecondary =
            this.transactionData[title.secondary.dataField];
      }
    },

    setColumnsData() {
      if (!this.screenJson.gridData) {
        this.dataLoaded = true;
        return;
      }
      if (this.screenJson.gridData.gridOptions.dynamicColumns)
        this.refreshDataGrid = true;
      var col = [];
      this.childGridColumns = undefined;

      if (this.dataViewType) {
        if (this.screenJson.gridData.gridOptions.dataGridViews) {
          let defaultValue =
            this.screenJson.gridData.gridOptions.dataGridViews.filter((x) => {
              if (x.value == this.dataViewType) return x;
            });

          if (defaultValue && defaultValue[0].columns) {
            col = defaultValue[0].columns;
            if (defaultValue[0].childColumns)
              this.childGridColumns = defaultValue[0].childColumns;
          } else {
            col = this.screenJson.gridData.columns;
          }
        } else {
          col = this.screenJson.gridData.columns;
        }
      } else {
        if (this.screenJson.gridData.gridOptions.dataGridViews) {
          let defaultValue =
            this.screenJson.gridData.gridOptions.dataGridViews.filter((x) => {
              if (x.default) return x.value;
            });

          // this.$store.dispatch(
          //   "dataContext/setDataViewType",
          //   defaultValue[0].value
          // );
          if (defaultValue && defaultValue[0].columns) {
            col = defaultValue[0].columns;
            if (defaultValue[0].childColumns)
              this.childGridColumns = defaultValue[0].childColumns;
          } else {
            col = this.screenJson.gridData.columns;
          }
        } else {
          col = this.screenJson.gridData.columns;
        }
      }
      col.forEach((element) => {
        if (element.screenField == "GridRecordEllipsisMenu") {
          if (!element.ellipsisMenu)
            element.ellipsisMenu = this.screenJson.gridData.ellipsisColumn;
        }
      });

      this.columns = col;
      this.dataLoaded = true;
      setTimeout(() => {
        this.refreshDataGrid = false;
      }, 100);
    },
    async saveTransaction(isValid, brokenRules, extra) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        let detailLines = this.screenJson.gridData
          ? this.$refs.transactionGrid.getDataSource()
          : undefined;
        if (this.getHeaderToolbarData.headerToolbar.saveCallback)
          this.getHeaderToolbarData.headerToolbar.saveCallback(
            this.transactionData,
            detailLines
          );
        if (!this.screenJson.gridData) return;
        if (this.screenJson.gridData.toolbar.saveCallback) {
          this.screenJson.gridData.toolbar.saveCallback(
            this.transactionData,
            detailLines,
            extra
          );
        }
      }
    },
  },
  watch: {
    refreshHeaderFormProp(val) {
      this.refreshHeaderForm = val;
    },
    refreshDataGridProp(val) {
      this.refreshDataGrid = val;
    },
    displayServerErrorPopUp(val) {
      if (val) {
        this.displayServerError(val.error, val.title);
      }
    },
    dataChangedIndex: function () {
      this.setFooterItems();
    },
    setLoading(val) {
      this.showLoading(val);
    },
    dataModel: {
      handler(val) {
        this.transactionData = val;
      },
      deep: true,
    },
    isLoaded(val) {
      if (val) {
        this.getTransactions();
      }
    },
    validationSummary: {
      handler(val) {
        if (val.length > 0) {
          this.displayValidationSummary(val);
        }
      },
      deep: true,
    },
    dataViewType(val) {
      if (val) {
        this.setColumnsData();
      }
    },
    serverError: {
      handler(val) {
        this.displayServerError(val.err, val.msg);
      },
      deep: true,
    },
    gcPopupConfig: {
      handler(val) {
        this.gcPopupVisible = val.gcPopupVisible;
      },
      deep: true,
    },
    gcPopupDataGridConfig: {
      handler(val) {
        this.gcPopupDataGridVisible = val.gcPopupVisible;
      },
      deep: true,
    },
    warningSummary: {
      handler(val) {
        if (val.length > 0) {
          this.displayWarningSummary(val);
        }
      },
      deep: true,
    },
    refreshColumns(val) {
      if (val) this.setColumnsData();
    },
  },
};
</script>

<style lang="scss">
.transaction-template {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: initial;
  }
}

.dx-datagrid .dx-scrollview-content {
  margin-top: 10px;
}

.save-btn-area {
  position: absolute;
  bottom: 0;
  width: 100%;
  .dx-button-content {
    background-color: #03a9f4;
    .dx-button-text,
    .dx-icon::before {
      color: white !important;
    }
  }
}

.gc-footer-value {
  font-size: 16px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.gc-header-comment-item-container {
  .dx-field-item-label-location-left {
    padding-top: 6px !important;
    white-space: normal !important;
  }

  .dx-field-item-label-content {
    width: 120px !important;
  }

  textarea {
    padding-top: 0 !important;
  }
}
</style>
